import { Outlet, NavLink } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { AutoBootstrapGate } from '@/components/app/AutoBootstrapGate';
import { useOrgBootstrap } from '@/hooks/useOrganization';
import { orgUiPath } from '@/core/api';
import { useOrgId } from '@/hooks/useOrgId';

export default function AppShell() {
  const orgId = useOrgId();
  const { needsSetup } = useOrgBootstrap();

  if (needsSetup) {
    return <AutoBootstrapGate />;
  }

  const mobileNav = [
    { to: orgUiPath(orgId, '/'), icon: 'dashboard', label: 'Dash', end: true },
    { to: orgUiPath(orgId, '/formats'), icon: 'grid_view', label: 'Formats', end: false },
    { to: orgUiPath(orgId, '/campaigns'), icon: 'campaign', label: 'Camp', end: false },
    { to: orgUiPath(orgId, '/creatives'), icon: 'auto_awesome', label: 'Creatives', end: false },
  ];

  return (
    <div className="aspectly:flex aspectly:min-h-screen aspectly:bg-surface aspectly:text-on-surface">
      <Sidebar />
      <Header />
      <main className="aspectly:md:ml-64 aspectly:mt-16 aspectly:mb-16 aspectly:md:mb-0 aspectly:pb-safe aspectly:flex-1 aspectly:min-h-[calc(100vh-4rem)] aspectly:flex aspectly:flex-col aspectly:pt-4 aspectly:md:pt-0">
        <Outlet />
      </main>

      <nav className="aspectly:md:hidden aspectly:fixed aspectly:bottom-0 aspectly:left-0 aspectly:right-0 aspectly:bg-white aspectly:border-t aspectly:border-stone-200 aspectly:flex aspectly:justify-around aspectly:p-1 aspectly:z-50 aspectly:items-center">
        {mobileNav.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `aspectly:flex aspectly:flex-col aspectly:items-center aspectly:justify-center aspectly:w-16 aspectly:h-14 aspectly:rounded-lg aspectly:transition-colors ${
                isActive
                  ? 'aspectly:text-primary aspectly:font-bold'
                  : 'aspectly:text-on-surface-variant aspectly:hover:text-primary aspectly:hover:bg-primary-container/20'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className="material-symbols-outlined aspectly:text-[20px] aspectly:mb-0.5"
                  style={isActive ? { fontVariationSettings: "'FILL' 1" } : undefined}
                >
                  {item.icon}
                </span>
                <span className="aspectly:text-[9px] aspectly:truncate">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
